<template>
  <div>
    <thread-for-archive v-if="!thread.isDeleted" :thread-url="thread.threadPermalinkUrl"
                        :last-message-sent-at="thread.lastMessageSentAt" :replies="thread.replies" :is-deleted="thread.isDeleted"
                        :author="thread.author" :title="thread.title" />
    <div v-else class="deleted-message">
      <a :href="thread.threadPermalinkUrl">{{ i18n.t('member.forums.deleted_message') }}</a>
    </div>
  </div>
</template>

<script>
import ThreadForArchive from './thread-for-archive'

export default {
  components: { ThreadForArchive },

  props: {
    thread: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
  .deleted-message {
    width: 100%;
    display: flex;
    padding: 15px 0;

    a {
      // Remove link default styling
      text-decoration: none;
      color: unset;
    }
  }
</style>
